import React from 'react';
import {  Modal, Tabs, Tab } from "react-bootstrap";
import PDFPrinting from '../containers/PDFPrinting';
import {constants} from '../containers/common/commonExport';

const ActivityModalNCNP = (props) => (
    
    <Modal show={ props.showModal && (props.modalName == constants.hosModals.Certify_Modal)}
        onHide={props.onHideModal()} className="activityModalContainer"
        bsSize="large" aria-labelledby="contained-modal-title-lg">
        <Modal.Header closeButton>
            <Modal.Title>
                <span className="activity-header"> {props.modalTitle} </span>
            </Modal.Title>
           
            <PDFPrinting hidden = {(props.modalName == constants.hosModals.Certify_Modal) ? true:false} Page="Projects" data = {props.workday.duty_activity} compTitle = {props.modalTitle} isLoading= {props.isLoading} validWorkday={props.validWorkday} />
            
        </Modal.Header>
        <div className={!props.activityErrPopup ? ( "animated fadeOut hidden" ) : (
                            "animated fadeIn errAlertDiv alert alert-danger fade in alert-dismissable"
                )}>
            <a className="close" onClick={props.oncloseErrPop()} data-dismiss="alert"
                aria-label="close" title="close" >×</a>
            <strong>{props.latestRecords ? 'Error' : 'Warning'}!</strong> {props.activityErrMessage}
        </div>
        <Modal.Body>
            <Tabs id="tabs" activeKey={props.isEdit ? props.eventKey == 1 ? props.eventKey+1 : props.eventKey  : props.eventKey}
                        onSelect={props.handleTabChange()}>
                        <Tab eventKey={1} title="Summary" disabled={props.isEdit}>
                            <div className="activityModal content-border">{props.renderCertifyModal(props.defaultWorkday)}</div>                
                        </Tab>
                        <Tab eventKey={2} title="Details">
                            <div className="activityModal content-border">{props.renderCertifyModal(props.defaultWorkday)}</div>
                        </Tab>
                        <Tab eventKey={3} title="E&D">
                           {props.renderEnDTab()}
                        </Tab>
                    </Tabs>
            
        </Modal.Body>
        <Modal.Footer>
            <div>
                <button className={"activitiesCancelBtn btn btn-primary btnWidth btnPrimaryColor"}
                    onClick={props.onHideModal()}> Close
                </button>
            </div>
        </Modal.Footer>
    </Modal>
);

export default ActivityModalNCNP;
